import React from 'react';
import { Link, Stack, Typography } from '@mui/material';
import {
  Breadcrumb,
  BreadcrumbLabel,
} from 'src/components/MainPage/_shared/Breadcrumbs/Breadcrumb';
import { useNavigate } from 'react-router';

export const WarehouseIncomeNotFound = () => {
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" py={6} gap={1} flex={1} justifyContent="center">
      <Typography variant="h6" color="text.secondary">
        Невозможно отобразить акт приёмки
      </Typography>
      <Typography variant="body2" color="text.disabled">
        Похоже, что документа с таким идентификатором не существует, либо доступ
        к нему ограничен.
      </Typography>

      <Link
        onClick={() => navigate(-1)}
        sx={{ mt: 2, cursor: 'pointer', textDecoration: 'none' }}
      >
        <Breadcrumb color="primary">
          <BreadcrumbLabel title="Назад" arrow />
        </Breadcrumb>
      </Link>
    </Stack>
  );
};
